module.exports = __webpack_public_path__ + "assets/images/glassShade-03.576b96b27c2894c42d821f4c486c9c6a.svg";